module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_FA.14f36de6.txt";